import "./NotInSeasonPage.css";
import { useAuthUser } from "../hooks/useAuthUser";

import LOGO from "../../../assets/images/logo/LOGO.svg";
import FloatingMenu from "../components/menu/FloatingMenu";

const NotInSeasonPage = ({ message }: { message: React.ReactNode }) => {
  const { isSocial, details } = useAuthUser();
  const displayName = isSocial ? details?.firstName : details?.companyName;

  return (
    <div className="not-in-season-page">
      <div className="message-flex">
        <div className="message-container">
          <h1>Hi, {displayName}</h1>
          <div>{message}</div>
          <div className="image">
            <img src={LOGO} alt="Alnarp's Farm Logo" />
          </div>
        </div>
      </div>
      <FloatingMenu logoutButton={true} homeButton={true} isBusiness={false} />
    </div>
  );
};

export default NotInSeasonPage;
